import React from 'react';

function Footer() {
  return (
    <footer className="tc-footer-style1 border-top">
      <div className="container">
        <div className="top-content section-padding">
          <div className="row gx-0">
            <div className="col-lg-4">
              <div className="info-side">
                <div className="text fsz-24 color-333 lh-3 fw-600">
                  We believe that architecture has the power to shape lives and
                  uplift communities. AGI&lsquo;s philosophy is passion for
                  innovation, sustainablity and timeless aesthetics
                </div>
                <div className="foot-social mt-50">
                  <a href="#">
                    <i className="fab fa-x-twitter"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/artisanguildinfra?igsh=c2FlYzFvY3lrZnRu">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 offset-lg-2">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Chennai, TN </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#">1st Main, Madurai Manavalan Nagar, Pooniammanmedu– 600110</a>
                  </li>
                  <li>
                    <a href="#"> operations@artisanguildinfra.com </a>
                  </li>
                  <li>
                    <a href="tel:+91 87545 05413"> +91 87545 05413 </a>
                  </li>
                </ul>
              </div>
              <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600"> Fabrication Unit </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#"> Kunnathur, Coimbatore, Tamil Nadu - 641110 </a>
                  </li>
              
                </ul>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 mt-lg-0 fw-600"> Kozhikode, KL </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#">Karaparamba, Malikadavu Road – 673010</a>
                  </li>
                  <li>
                    <a href="mailto:operations@artisanguildinfra.com"> operations@artisanguildinfra.com </a>
                  </li>
                  <li>
                    <a href="tel:+91 87545 05413"> +91 87545 05413 </a>
                  </li>
                </ul>
              </div>
              <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600"> Helps </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#"> Term & Conditions </a>
                  </li>
                  <li>
                    <a href="#"> Partner Policy </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row">
            <div className="col-lg-6">
              <p className="fsz-13">© 2025 Artisan Guild Infra. All Right Reserved</p>
            </div>
            <div className="col-lg-6">
              <div className="foot-links mt-4 mt-lg-0">
                <a href="/"> Home </a>
                <a href="/about"> About </a>
                <a href="/services"> Services </a>
                <a href="/portfolio"> Projects </a>
                <a href="/contact"> Contact </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
